(function () {
  var STORAGE_KEY = 'elleebana_welcome_gift_dismissed';
  document.addEventListener('DOMContentLoaded', function () {
    if (sessionStorage.getItem(STORAGE_KEY)) return;
    var popup = document.getElementById('WelcomeGiftPopup');
    if (!popup) return;
    popup.style.display = 'block';
    var closeBtn = popup.querySelector('[data-close-welcome-gift]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        popup.style.display = 'none';
        sessionStorage.setItem(STORAGE_KEY, '1');
      });
    }
  });
})();
